import { useQuery } from '@tanstack/react-query';

import { sdk } from '@/services';

const ActivityService = sdk.getService('ActivityService');

export const useActivityByQuiz = (quizId: string | undefined) => {
  const { data, isLoading, error } = useQuery({
    queryKey: ['activities', quizId],
    queryFn: () => ActivityService.getQuizActivities(quizId!),
    enabled: !!quizId
  });

  return {
    activities: data,
    isWorking: isLoading,
    error
  };
};
